// extracted by mini-css-extract-plugin
export default {"lowSupplyCrossSell":"lowSupplyCrossSell__MmRmN","info":"info__ZDRiN","vendorIcon":"vendorIcon__ZjkyZ"};